export const partnershipBenefits = [
  "Parceria com zero custos pra você e sua empresa.",
  "Reduza em 40% o tempo nos seus processos seletivos.",
  "Tenha a garantia de devs com alto comprometimento com hard skills e soft skills bem desenvolvidas.",
  "Ganhe assertividade: Nós vamos te ajudar a encontrar os melhores programadores.",
];

export const partnershipSteps = [
  {
    backgroundColor: "#FFFFFF",
    numberColor: "#0000FF",
    cardNumber: "1",
    paragraphColor: "#2D2D2D",
    paragraph:
      "Você se cadastra gratuitamente e entra em nossa base de parceiras oficiais.",
  },
  {
    backgroundColor: "#E1EBFF",
    numberColor: "#0000FF",
    cardNumber: "2",
    paragraphColor: "#2D2D2D",
    paragraph:
      "Compartilha com a Kenzie o perfil descritivo da vaga que você precisa fechar.",
  },
  {
    backgroundColor: "#6184FF",
    numberColor: "#FFFFFF",
    cardNumber: "3",
    paragraphColor: "#FFFFFF",
    paragraph:
      "Nós vamos selecionar os melhores devs de acordo com o perfil da sua vaga.",
  },
  {
    backgroundColor: "#0000FF",
    numberColor: "#FFFFFF",
    cardNumber: "4",
    paragraphColor: "#FFFFFF",
    paragraph:
      "O match entre Dev Kenzie & Empresa torna-se muito mais efetivo.",
  },
];
